var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconfeatherPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.197,
    height: 16.196,
    viewBox: "0 0 16.197 16.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone-call",
    "data-name": "Icon feather-phone-call",
    d: "M12.091,4.254a3.445,3.445,0,0,1,2.724,2.719M12.091,1.5a6.2,6.2,0,0,1,5.483,5.466m-.69,5.493v2.065a1.378,1.378,0,0,1-1.5,1.377,13.666,13.666,0,0,1-5.952-2.113,13.436,13.436,0,0,1-4.138-4.13A13.606,13.606,0,0,1,3.173,3.689a1.378,1.378,0,0,1,1.372-1.5H6.615A1.379,1.379,0,0,1,7.994,3.372a8.825,8.825,0,0,0,.483,1.934,1.375,1.375,0,0,1-.31,1.452l-.876.874a11.025,11.025,0,0,0,4.138,4.13l.876-.874a1.381,1.381,0,0,1,1.455-.31,8.87,8.87,0,0,0,1.938.482A1.378,1.378,0,0,1,16.885,12.459Z",
    transform: "translate(-2.317 -0.562)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherPhoneCall);
export default __webpack_public_path__ + "static/media/Icon feather-phone-call.17254ff25822d23c03c0ae0ab2dbe9c1.svg";
export { ForwardRef as ReactComponent };